module.exports = __webpack_public_path__ + "img/index7.10c35cb8.webp";